<form [formGroup]="form" class="form">
  <div class="salary">
    <i class="icon-close icon big-close" DialogClose="cancel"></i>
    <h2 class="dialog-title m-0 p-0">Salary</h2>
    <div class="dialog-content">
      <div class="row mb-4">
        <div class="row col-6 align-items-center p-0">
          <label
            class="col-4 label-input"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'increaseDate'"
            [touched]="increaseDate.touched"
            >Active from
          </label>
          <div class="col-8 form-validation">
            <div
              class="detepicker-padding custom-input"
              [class.custom-input-empty]="!increaseDate.value"
              [class.custom-input-filled]="increaseDate.value"
            >
              <app-datepicker
                [iconLeft]="true"
                [minDeadLine]="previousMonth"
                formControlName="increaseDate"
                [monthVisible]="true"
                [fontSize]="14"
                [staticPropery]="true"
              ></app-datepicker>
            </div>
            <app-error-field
              [displayError]="
                increaseDate.invalid &&
                increaseDate.hasError('required') &&
                increaseDate.touched
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="increaseDate.hasError('hasPendingIncrease')"
              [errorMessage]="'Selected month already has a pending increase'"
            ></app-error-field>
          </div>
        </div>
        <div class="row col-6 align-items-center p-0">
          <label
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'increaseReason'"
            [touched]="increaseReason.touched"
            class="col-4 label-input"
            >Increase reason
          </label>
          <div class="col-8 form-validation">
            <div
              class="custom-input"
              [class.custom-input-empty]="!increaseReason.value"
              [class.custom-input-filled]="increaseReason.value"
            >
              <app-dropdown
                [border]="'none'"
                [items]="data.increaseReasonItems"
                formControlName="increaseReason"
              ></app-dropdown>
            </div>
            <app-error-field
              [displayError]="increaseReason.invalid && increaseReason.touched"
              [errorMessage]="'The field is required'"
            ></app-error-field>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="row col-6 align-items-center p-0" *ngIf="!isContractor">
          <label
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'salaryStavka'"
            [touched]="salaryStavka.touched"
            class="col-4 label-input"
            >Salary stavka $
          </label>
          <div class="col-8 form-validation">
            <input
              type="number"
              class="input__basic"
              placeholder=" "
              formControlName="salaryStavka"
            />
            <app-error-field
              [displayError]="
                salaryStavka.invalid &&
                salaryStavka.hasError('required') &&
                salaryStavka.touched
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="salaryStavka.hasError('max')"
              [errorMessage]="'Max value = 999999'"
            ></app-error-field>
            <app-error-field
              [displayError]="salaryStavka.hasError('min')"
              [errorMessage]="'The value should be greater than 0'"
            ></app-error-field>
          </div>
        </div>
        <div class="row col-6 align-items-center p-0">
          <label
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'ratePerHour'"
            [touched]="ratePerHour.touched"
            class="col-4 label-input"
            >Rate per hour
          </label>
          <div class="col-8 form-validation">
            <input
              type="number"
              class="input__basic"
              placeholder=" "
              formControlName="ratePerHour"
            />
            <app-error-field
              [displayError]="
                ratePerHour.invalid &&
                ratePerHour.hasError('required') &&
                ratePerHour.touched
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="ratePerHour.hasError('max')"
              [errorMessage]="'Max value = 999'"
            ></app-error-field>
            <app-error-field
              [displayError]="ratePerHour.hasError('min')"
              [errorMessage]="'The value should be greater than 0'"
            ></app-error-field>
          </div>
        </div>
      </div>
      <div class="row mb-4">
        <div class="row col-6 align-items-center p-0">
          <label class="col-4 label-input">Total, $</label>
          <div class="col-8 form-validation">
            <p class="salary-total">{{ total }}</p>
          </div>
        </div>
      </div>
      <div class="row mb-4" *ngIf="!isContractor">
        <div class="row col-6 align-items-center p-0">
          <label
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'constPart'"
            [touched]="constPart.touched"
            class="col-4 label-input"
            >ConstPart
          </label>
          <div class="col-8 form-validation">
            <input
              type="number"
              class="input__basic"
              placeholder=" "
              formControlName="constPart"
            />
            <app-error-field
              [displayError]="
                constPart.invalid &&
                constPart.hasError('required') &&
                constPart.touched
              "
              [errorMessage]="'The field is required'"
            ></app-error-field>
            <app-error-field
              [displayError]="constPart.hasError('max')"
              [errorMessage]="'Max value = 1'"
            ></app-error-field>
            <app-error-field
              [displayError]="constPart.hasError('min')"
              [errorMessage]="'Min value > 0'"
            ></app-error-field>
          </div>
        </div>
      </div>
      <div class="row align-items-center">
        <div class="col-2">
          <label
            class="label-input"
            appMarkAsterisk
            [formGroup]="form"
            [controlName]="'comment'"
            [touched]="comment.touched"
            >Comment</label
          >
        </div>
        <div class="col-10 input__wrapper">
          <textarea
            type="textarea"
            class="input__textarea input__basic"
            placeholder=" "
            formControlName="comment"
          >
          </textarea>
          <app-error-field
            [displayError]="comment.hasError('wordCount')"
            [errorMessage]="'Max field length = 400 words'"
          ></app-error-field>
        </div>
      </div>
    </div>
    <div class="dialog-buttons">
      <button
        class="button button__save add-margin"
        type="button"
        (click)="addIncreaseSalary()"
      >
        Save
      </button>
      <button class="button button__cancel" type="button" DialogClose>
        Cancel
      </button>
    </div>
  </div>
</form>
